import styles from './styles.module.css';
import { SearchComponent } from './search-component';
import { Layout } from 'components/layout';
import { Breadcrumbs } from 'components/bredcrambs';
import { search } from 'constants/routes-breadcrumbs';

export const Search = () => {
  return (
    <div>
      <Layout hasFooter isSearchInputMobileVisible={false}>
        <main className={styles.main}>
          <div className={styles.container}>
            <div className={styles.breadcrumbs}>
              <Breadcrumbs items={[...search]} />
            </div>
            <SearchComponent />
          </div>
        </main>
      </Layout>
    </div>
  );
};
